'use client';

import { c as _c } from "react/compiler-runtime";
import type { Cart } from '@feat/feat-cart/cart';
import { CartSummary } from '@feat/feat-cart/cart-summary';
import { getTouristTaxType } from '@feat/feat-cart/pricing';
import { getHotelAdsCartItem } from '../_lib/hotel-ads-cart-item';
import { CartAccommodationOfferMicrodata } from './cart-accommodation-offer-microdata';
export function CartTotalSummary(t0) {
  const $ = _c(9);
  const {
    cart
  } = t0;
  let t1;
  if ($[0] !== cart) {
    t1 = getHotelAdsCartItem(cart);
    $[0] = cart;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const hotelAdsItem = t1;
  const t2 = hotelAdsItem?.statusAccommodation === "AVAILABLE";
  let t3;
  if ($[2] !== cart || $[3] !== t2) {
    t3 = <CartSummary cart={cart} title="Zusammenfassung" microdata={t2} highlightTaxNote={true} />;
    $[2] = cart;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const summary = t3;
  if (!hotelAdsItem) {
    return summary;
  }
  const t4 = !getTouristTaxType(cart);
  let t5;
  if ($[5] !== hotelAdsItem || $[6] !== summary || $[7] !== t4) {
    t5 = <CartAccommodationOfferMicrodata item={hotelAdsItem} taxIncluded={t4}>{summary}</CartAccommodationOfferMicrodata>;
    $[5] = hotelAdsItem;
    $[6] = summary;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}